// extracted by mini-css-extract-plugin
module.exports = {"groups":"ConceptGroups-module__groups__1zBAT"};